var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#645CFC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2212 14.956C22.3349 14.5577 22.1043 14.1426 21.7061 14.0288C21.3078 13.915 20.8927 14.1456 20.7789 14.5439L17.7789 25.0439C17.6651 25.4422 17.8957 25.8573 18.294 25.9711C18.6922 26.0849 19.1074 25.8543 19.2212 25.456L22.2212 14.956Z",
    fill: "#645CFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0303 16.2197C17.3232 16.5126 17.3232 16.9874 17.0303 17.2803L14.3107 20L17.0303 22.7197C17.3232 23.0126 17.3232 23.4874 17.0303 23.7803C16.7374 24.0732 16.2626 24.0732 15.9697 23.7803L12.7197 20.5303C12.4268 20.2374 12.4268 19.7626 12.7197 19.4697L15.9697 16.2197C16.2626 15.9268 16.7374 15.9268 17.0303 16.2197Z",
    fill: "#645CFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9697 23.7803C22.6768 23.4874 22.6768 23.0126 22.9697 22.7197L25.6893 20L22.9697 17.2803C22.6768 16.9874 22.6768 16.5126 22.9697 16.2197C23.2626 15.9268 23.7374 15.9268 24.0303 16.2197L27.2803 19.4697C27.5732 19.7626 27.5732 20.2374 27.2803 20.5303L24.0303 23.7803C23.7374 24.0732 23.2626 24.0732 22.9697 23.7803Z",
    fill: "#645CFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCodeIcon);
export default __webpack_public_path__ + "static/media/copy_code_icon.b90b348eaf1611e59df48efe0e0281cb.svg";
export { ForwardRef as ReactComponent };